import type GlobalModel from 'echarts/lib/model/Global';
import type ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import { util } from 'echarts/core';
import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type AxisModel from 'echarts/lib/coord/cartesian/AxisModel';
import { isFunction } from 'zrender/lib/core/util';

// 已经适用的轴线类型
const usageAxisTypes = ['xAxis', 'yAxis', 'singleAxis'];

function splitLineExtend(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterupdate', (ecModel: GlobalModel, api: ExtensionAPI) => {
    ecModel.eachComponent((componentType: string, compModel: AxisModel) => {
      if (!usageAxisTypes.includes(componentType) || !compModel?.get('show')) {
        return;
      }

      const { option } = compModel;
      const compView = api.getViewOfComponentModel(compModel);
      const lines = [];
      // @ts-ignore
      (compView.group as Group).traverse(childEl => {
        if ((childEl.anid || '').startsWith('line_')) {
          lines.push(childEl as Text);
        }
      });

      // 自定义分割线样式
      if (isFunction(option?.splitLine?.lineStyle)) {
        lines.forEach((line, index) => {
          const { anid = '' } = line;
          const label = anid.split('_')[1];
          const lineStyle = { ...line.style };
          const customLineStyle = option.splitLine.lineStyle(index, label);
          util.merge(lineStyle, customLineStyle, true);
          line.attr({ style: lineStyle });
        });
      }

      // IOS16分割线样式异常补丁
      lines.forEach(line => {
        const { lineWidth } = line.style;
        line.attr({ style: { lineWidth: lineWidth * (1 + 0.1 * (0.5 + 0.5 * Math.random())) } });
      });
    });
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  splitLineExtend(registers);
}
